/**
 * Immediate header copy for "translating / localizing" while AI sync runs.
 * Shown before Firestore + Gemini finish for the rest of app_main — keeps the
 * indicator readable in the user's chosen language from the first frame.
 */
const BY_LANG = {
  es: 'Traduciendo…',
  zh: '正在翻译…',
  ja: '翻訳中…',
  tl: 'Isinasalin…',
  ms: 'Menterjemah…',
  ar: 'جارٍ الترجمة…',
  fr: 'Traduction…',
  nl: 'Bezig met vertalen…',
  de: 'Wird übersetzt…',
  ru: 'Перевод…',
  pt: 'A traduzir…',
  it: 'Traduzione in corso…',
  ko: '번역 중…',
  hi: 'अनुवाद हो रहा है…',
  ur: 'ترجمہ جاری ہے…',
};

export function getTranslatingIndicator(langKey) {
  if (!langKey || langKey === 'en') return 'Translating';
  const raw = String(langKey).trim();
  if (BY_LANG[raw]) return BY_LANG[raw];
  const base = raw.split(/[-_]/)[0];
  return BY_LANG[base] || 'Translating';
}
